import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { HeaderTwo } from 'secondstep-components'

export const K8Tier2ViewContainer = styled.div`
  background-color: ${themeGet('colors.white')};
  padding: 1.5rem 1.25rem 1.25rem;
  border-radius: 0.625rem;
  position: relative;
`

export const LastUpdatedAtText = styled.span`
  position: absolute;
  top: 15px;
  right: 20px;
  color: ${themeGet('colors.gray1100')};
  font-size: 0.75rem;
`

export const LoadingMessage = styled.div`
  margin-top: 1rem;
`

export const SiteHeader = styled.div`
  margin-bottom: 0.6875rem;
`

export const TierPill = styled.div`
  margin: 0 0 0.6875rem 1.125rem;

  span {
    background: ${themeGet('colors.aliceBlue')};
    color: ${themeGet('colors.darkGray')};
    font-weight: 600;
    font-size: 0.75rem;
    letter-spacing: 0.08em;
    padding: 0.375rem 1rem 0.25rem;
    border-radius: 6.25rem;
  }
`

export const Title = styled(HeaderTwo)`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  color: ${themeGet('colors.darkBlue')};
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`
